import React, { Component } from 'react';
import Swiper from 'swiper';
export default class TeamGrid extends Component {
	componentDidMount() {
		new Swiper('.TeamGrid', {
			speed: 400,
			slidesPerView: 'auto',
			preloadImages: true,
			lazy: true,
			watchSlidesVisibility: true,
			slideClass: 'grid-item',
			allowTouchMove: false,

			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev'
			},
			on: {
				init: function() {
					if (window.innerWidth >= 768) {
						this.allowTouchMove = false;
					} else {
						this.allowTouchMove = true;
						this.slideTo(0);
					}
					this.update();
				},
				resize: function() {
					if (window.innerWidth >= 768) {
						this.allowTouchMove = false;
					} else {
						this.allowTouchMove = true;
						this.slideTo(0);
					}
					this.update();
				}
			}
		});
	}

	render() {
		return (
			<div className="TeamGrid swiper-container">
				<div className="swiper-wrapper">
					{this.props.children ? (
						this.props.children
					) : (
						<p>Geen content beschikbaar</p>
					)}
				</div>
				<div className="swiper-button-container">
					<div className="swiper-button-prev">
						<span />
						<span />
						<span />
					</div>
					<div className="swiper-button-next">
						<span />
						<span />
						<span />
					</div>
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/TeamGrid/TeamGrid.jsx